import React, { useEffect, useRef, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from "primereact/dropdown";
import { Toast, ToastMessage } from "primereact/toast";
import OrderTabPanel from "./OrderTabPanel"; 
import { Button } from "primereact/button";
import { getOpenOrderUserAddresses } from '../../services/order/order.service';
import routeCodeServices from '../../services/route-codes/routecode.service';
import orderServices from '../../services/orders/orderservice';
import { AssignCode } from '../../models/route-code/routecode-model';
import { Dialog } from "primereact/dialog";
import GetAddressByLocation from "../user-address/location-search/get-location";
import UserAddressService from "../../services/useraddress/useraddress.service";
import { CustomerAddressModel1 } from "../../models/cust-address/cust-address-model";
import AppLoading from '../app-loading/app-loading';
import { useLocation } from "react-router-dom";

interface UserOption {
  userID: number;
  name: string;
  primaryContactNbr: string;
}

const OpenOrders = () => {
  const toast = useRef<Toast>(null);
  // const [selectedType, setSelectedType] = useState<number>(1);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialTab = params.get("tab") === "geo" ? 2 : 1;
  const [selectedType, setSelectedType] = useState<number>(initialTab);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [orderUserOptions, setOrderUserOptions] = useState<any[]>([]);
  const [userData, setUserData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [routeCodeOptions, setRouteCodeOptions] = useState<{ label: string; value: number }[]>([]);
  const [orderUsers, setOrderUsers] = useState<UserOption[]>([{ userID: 0, name: '', primaryContactNbr: '' }]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLocationMapVisible, setIsLocationMapVisible] = useState(false);
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [filteredUser, setFilteredUser] = useState<any>(null);
  const [selectedOrderId, setSelectedOrderId] = useState<number | null>(null);
  const showMessage = (label: string, message: string, severity: ToastMessage['severity']) => {
    toast.current?.show({ severity: severity, summary: label, detail: message, life: 3000 });
  };

  useEffect(() => {
    fetchData(pageNumber, pageSize);
  }, [selectedType, pageNumber, pageSize]);

  useEffect(() => {
    fetchData(1, pageSize);
  }, [filteredUser]);

const fetchData = async (page: number, size: number) => {
  setLoading(true);
  try {
    const response = await getOpenOrderUserAddresses({
      pageNumber: page,
      pageSize: size,
      type: selectedType,
      userID: filteredUser || null, // use filteredUser here
    });
    setUserData(response.addresses || []);
    setTotalRecords(response.totalRecords || 0);
  } catch (error) {
    console.error("Fetch error:", error);
  } finally {
    setLoading(false);
  }
};

  const loadRouteCodes = async () => {
    try {
      const res = await routeCodeServices.getRouteCodes();
      const routeList = res?.routeCodes || res;
      if (Array.isArray(routeList)) {
        setRouteCodeOptions(routeList.map((rc: any) => ({ label: rc.name, value: rc.routeCodeID })));
      }
    } catch (err) {
      console.error("Error loading route codes", err);
    }
  };

  useEffect(() => {
    setOrderUserOptions(orderUsers.map(user => ({
      userID: user.userID,
      detail: `${user.name}, ${user.primaryContactNbr}`,
    })));

    loadRouteCodes();
  }, []);

  const handlePageChange = (event: { first: number; rows: number }) => {
    setPageNumber(Math.floor(event.first / event.rows) + 1);
    setPageSize(event.rows);
  };

  const onRowEditComplete = async (e: any) => {
  const { newData } = e;
  const selectedRouteCodeID = Number(newData.routeCodeID || 0);
  const userAddressID = newData.userAddressID;


  if (!userAddressID) {
    console.error("Error: userAddressID is missing!");
    return;
  }

  if (selectedRouteCodeID ) {
    try {
      const putData: AssignCode = {
        userAddressID,
        routeCodeID: selectedRouteCodeID,
      };
      const response = await routeCodeServices.assignRouteCode1(putData);

      if (response?.isSuccess) {
        toast.current?.show({
              severity: 'success',
              summary: 'Success',
              detail: response.message || 'Route Code updated successfully.',
              // detail: response.message,
              life: 3000,
            });

            setTimeout(async () => {
              await fetchData(pageNumber, pageSize);
            }, 1000);

          } else {
            console.error("API Update Failed", response);
          }
        } catch (error) {
          console.error("API Error:", error);
        }
      }
      };

  const routeCodeEditor = (options: any) => (
    <Dropdown
      className="border-1 border-primary"
      value={options.value}
      options={routeCodeOptions}
      onChange={(e: DropdownChangeEvent) => options.editorCallback!(e.value)}
      style={{ textAlign: "right", width: "8em" }}
      placeholder="Choose"
    />
  );

  const otherActionTemplate = (rowData: any) => {
    return (
      <div className="flex">
        <Button
          icon="pi pi-map-marker"
          onClick={() => {setIsLocationMapVisible(true); setSelectedId(rowData.userAddressID);setSelectedOrderId(rowData.orderID);}}
         style={{ border: 'none', color: 'gray', background: 'none'}}
          className="p-button-rounded p-button-text"
        />
        <Button
          icon="pi pi-arrow-circle-right"
         onClick={() => {openDirections(rowData)}}
         style={{ border: 'none', color: 'gray', background: 'none'}}
          className="p-button-rounded p-button-text"
        />
      </div>
    );
  };

  const handleDropdownChange = (e: DropdownChangeEvent) => {
    setSelectedUser(e.value);
  };

  const handleDropdownFilter = async (e: DropdownFilterEvent) => {
    if (e.filter.length > 2) {
      try {
        const users = await orderServices.getOrderUsers(e.filter);
        if (users.length > 0) {
          setOrderUsers(users);
          setOrderUserOptions(users.map((user: { userID: any; name: any; primaryContactNbr: any; }) => ({
            userID: user.userID,
            detail: `${user.name}, ${user.primaryContactNbr}`,
          })));
        }
      } catch (error) {
        console.error("Error filtering users:", error);
      }
    }
  };

const handleResetSearch = () => {
  setSelectedUser(null);
  setFilteredUser(null); // clear the filter
  fetchData(1, pageSize);
};

    const updateLatitudeAndLongitude = (location: string) => {
    if (location) {
      try {
        var locationSplit = location.split(",");
        setLatitude(parseFloat(locationSplit[0]));
        setLongitude(parseFloat(locationSplit[1]));
      } catch {
      }
    }
  }

  const getCurrentLocation = (): Promise<{ latitude: number, longitude: number }> => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const currLocation = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            };
            resolve(currLocation);
          },
          (error) => {
            console.error("Error getting current location:", error.message);
            reject(error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
  };

  const openDirections = (rowData: CustomerAddressModel1) => {
  const gpsLocation = rowData?.gpsLocation;
  if (!gpsLocation || !gpsLocation.includes(",")) {
    showMessage('Invalid GPS', 'GPS location not available. Please update the GPS.', 'error');
    return;
  }

  const gpsData = gpsLocation.split(",");
  if (gpsData.length !== 2 || isNaN(+gpsData[0]) || isNaN(+gpsData[1])) {
    showMessage('Invalid GPS', 'GPS coordinates are invalid.', 'error');
    return;
  }

  getCurrentLocation()
    .then((currentLocation) => {
      const start = `${currentLocation.latitude},${currentLocation.longitude}`;
      const destination = `${gpsData[0]},${gpsData[1]}`;
      const url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(start)}&destination=${encodeURIComponent(destination)}`;
      window.open(url, '_blank');
    })
    .catch((error) => {
      console.error("Error:", error.message);
      showMessage('Invalid GPS', 'Please update the GPS', 'error');
    });
};

  const updateGpsLocation = async (latLng: any) => {
    setIsLocationMapVisible(false);
    updateLatitudeAndLongitude(latLng);
    if(latLng && selectedId != null && selectedOrderId != null){
      const response=await UserAddressService.updateGPSLocation1(selectedId, latLng, selectedOrderId);
     if (response && response.isSuccess) {
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: 'GPS location updated successfully.',
          life: 3000,
        });

         setTimeout(async () => {
          await fetchData(pageNumber, pageSize);
        }, 1000);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: response?.message || 'Failed to update GPS location.',
          life: 3000,
        });
      }
    }    
  } 
const handleSearch = () => {
  if (!selectedUser) {
    showMessage("Info", "Please select a user to search.", "info");
    return;
  }
  setFilteredUser(selectedUser); 
}

  return (
    <div className="pt-2 px-6 pb-6 border border-gray-300 shadow-md rounded-lg bg-white">
      <Toast ref={toast} position="top-right" />
      <h2 className="text-2xl font-semibold text-gray-800 mb-6">
      Unassigned Orders
    </h2>
      <div className="flex mb-4 gap-3">
        <Dropdown
          id="SearchUser"
          name="SearchUser"
          options={orderUserOptions}
          optionLabel="detail"
          optionValue="userID"
          value={selectedUser}
          onChange={handleDropdownChange}
          onFilter={handleDropdownFilter}
          filter
          placeholder="Search for User/Mobile"
          style={{ width: "250px" }}
        />
    <Button
    label="Search"
    icon="pi pi-search"
    className="p-button-primary"
    onClick={handleSearch}
  />
  <Button label="Reset" icon="pi pi-refresh" className="p-button-secondary" onClick={handleResetSearch} />
</div>

      <TabView activeIndex={selectedType - 1} onTabChange={(e) => setSelectedType(e.index + 1)} className="mb-4">
  <TabPanel header="Unassigned Route Code">
    <OrderTabPanel
      userData={userData}
      loading={loading}
      pageNumber={pageNumber}
      pageSize={pageSize}
      totalRecords={totalRecords}
      onPageChange={handlePageChange}
      onRowEditComplete={onRowEditComplete}
      routeCodeOptions={routeCodeOptions}
      otherActionTemplate={otherActionTemplate}
      routeCodeEditor={routeCodeEditor}
      emptyMessage="All Route Codes are up to date" // <-- Add this line
    />
  </TabPanel>
  <TabPanel header="Unassigned Geo Code">
    <OrderTabPanel
      userData={userData}
      loading={loading}
      pageNumber={pageNumber}
      pageSize={pageSize}
      totalRecords={totalRecords}
      onPageChange={handlePageChange}
      onRowEditComplete={onRowEditComplete}
      routeCodeOptions={routeCodeOptions}
      otherActionTemplate={otherActionTemplate}
      routeCodeEditor={routeCodeEditor}
      emptyMessage="All Geo Codes are up to date" // <-- Add this line
    />
  </TabPanel>
</TabView>
      <Dialog
      header="Search your location"
      className="location-dialog"
      visible={isLocationMapVisible}
      onHide={() => setIsLocationMapVisible(false)}
      footer=""
      style={{ width: "50%" }}
    >
      <GetAddressByLocation
        getLatitudeLongitude={updateGpsLocation}
        lat={latitude}
        lng={longitude}
      />
    </Dialog>
    {loading && <AppLoading />}
    </div>
  );
};

export default OpenOrders;

